import { array, any, bool, string, func, object } from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'
import { actions, selectors } from '@opallabs/wormhole'
import PersonMultiSelect from '../PersonMultiSelect'
import {
  createUserFromMember,
  getDisplayValue,
  getSuggestedUsers,
} from './helpers'

export class PrivatePeoplePickerComponent extends Component {
  static propTypes = {
    accessGroupMembers: object,
    addNonRequired: bool,
    className: string,
    entityId: any,
    entityType: string.isRequired,
    momentAccessGroupMembers: func,
    noSearch: bool,
    noSuggestions: bool,
    onClearAll: func.isRequired,
    onRemove: func.isRequired,
    onSelect: func.isRequired,
    people: array,
    showSelected: bool,
    storyAccessGroupMembers: func,
    value: array,
  }

  componentDidMount() {
    const { entityId, entityType } = this.props
    if (entityType && entityId) {
      const fetcherMethod =
        entityType === 'story'
          ? this.props.storyAccessGroupMembers
          : this.props.momentAccessGroupMembers
      fetcherMethod(entityId)
    }
  }

  initialDisplayValue() {
    const {
      accessGroupMembers,
      addNonRequired,
      entityId,
      entityType,
      onSelect,
      value,
    } = this.props

    const users = getDisplayValue({
      accessGroupMembers,
      entityId,
      entityType,
      value,
    })

    if (addNonRequired) {
      const suggestedUsers = getSuggestedUsers({
        accessGroupMembers,
        entityId,
        entityType,
        value,
      })

      if (suggestedUsers.length) {
        setTimeout(() => {
          onSelect(...suggestedUsers)
        })
      }
    }

    return users
  }

  render() {
    const {
      className,
      noSearch,
      noSuggestions,
      onClearAll,
      onRemove,
      onSelect,
      people,
      showSelected,
    } = this.props

    const initialValue = this.initialDisplayValue()

    const selectableUsers =
      people &&
      people.filter((person) => {
        const userIndex = initialValue.findIndex((user) => {
          if (user === undefined) {
            return false
          }

          return parseInt(user.id, 10) === parseInt(person.id, 10)
        })

        const isUserAlreadyAdded = userIndex > -1
        return !isUserAlreadyAdded
      })

    return (
      <PersonMultiSelect
        avatared={true}
        className={className}
        noSearch={noSearch}
        noSuggestions={noSuggestions}
        onClearAll={onClearAll}
        onRemove={onRemove}
        onSelect={onSelect}
        options={selectableUsers}
        optionsType="users"
        showSelected={showSelected}
        optionDecorator={createUserFromMember}
        value={initialValue}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  accessGroupMembers: state.access_group_members || {},
  people: selectors.selectUsersToArray(state),
})

const mapDispatchToProps = (dispatch) => ({
  storyAccessGroupMembers: (id) => {
    dispatch(actions.getStoryAccessGroupMembers(id))
  },
  momentAccessGroupMembers: (id) => {
    dispatch(actions.getMomentAccessGroupMembers(id))
  },
})

const PrivatePeoplePicker = connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivatePeoplePickerComponent)

export default PrivatePeoplePicker
